// extracted by mini-css-extract-plugin
export default {"total-results":"ResultsPageTop_total-results__wQVec"};